export type ToolType =
    | 'select'
    | 'rectangle'
    | 'circle'
    | 'ellipse'
    | 'triangle'
    | 'diamond'
    | 'pentagon'
    | 'hexagon'
    | 'star'
    | 'heart'
    | 'check'
    | 'arrow'
    | 'cloud'
    | 'line'
    | 'polygon'
    | 'pen'
    | 'text'
    | 'image'
    | 'frame';

export interface Tool {
    type: ToolType;
    name: string;
    icon: string;
    shortcut?: string;
}

export const TOOLS: Tool[] = [
    { type: 'select', name: 'Select', icon: '→', shortcut: 'V' },
    { type: 'frame', name: 'Frame', icon: '📦', shortcut: 'F' },
    { type: 'pen', name: 'Pen', icon: '✏️', shortcut: 'B' },
    { type: 'text', name: 'Text', icon: 'A', shortcut: 'T' },
    { type: 'image', name: 'Image', icon: '🖼️', shortcut: 'I' }
];

export const SHAPE_TOOLS: Tool[] = [
    { type: 'rectangle', name: 'Rectangle', icon: '▭', shortcut: 'R' },
    { type: 'circle', name: 'Circle', icon: '⭕', shortcut: 'O' },
    { type: 'ellipse', name: 'Ellipse', icon: '⬯', shortcut: 'E' },
    { type: 'triangle', name: 'Triangle', icon: '△', shortcut: 'G' },
    { type: 'diamond', name: 'Diamond', icon: '◇', shortcut: 'D' },
    { type: 'pentagon', name: 'Pentagon', icon: '⬟', shortcut: 'N' },
    { type: 'hexagon', name: 'Hexagon', icon: '⬢', shortcut: 'H' },
    { type: 'star', name: 'Star', icon: '★', shortcut: 'S' },
    { type: 'check', name: 'Check', icon: '✓', shortcut: 'C' },
    { type: 'arrow', name: 'Arrow', icon: '➔', shortcut: 'A' },
    { type: 'line', name: 'Line', icon: '⟋', shortcut: 'L' },
    { type: 'polygon', name: 'Polygon', icon: '⬟', shortcut: 'P' }
];
